import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { configsService } from '@/services/http/configsService'

export const useScores = () => {
  const { toast } = useToast()

  const {
    data: scores,
    isError,
    isLoading,
    refetch: refetchScores,
  } = useQuery({
    queryKey: ['scores'],
    queryFn: () => configsService.getScores(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao buscar dados de pontuação',
        variant: 'destructive',
      })
  }, [isError, toast])

  return {
    scores,
    isLoading,
    refetchScores,
  }
}
